import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 12 9"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#0A850E",
      "stroke-linecap": "round",
      "stroke-width": "2",
      d: "M11 1 4 8M4 8 1 5M11 1 4 8M4 8 1 5"
    }, null, -1)
  ]))]))
}
export default { render: render }